const login = {
  routes: [
    {
      path:'/',
      redirect:'/login/:id'
    },
    {
      path: '/index',
      name: 'Welcome',
      meta:{
        breadcrumb:[
          {
            name:'首页',
            path:'/index'
          }
        ],
        isShowHeader:true,

      },
      component: () => import( '@/project/views/Welcome.vue')
    },
    {
      path: '/visitor-welcome/:id',
      name: 'visitorWelcome',
      meta:{
        isShowHeader:true,
      },
      component: () => import( '@/project/views/visitor-welcome.vue')
    },
    {
      path:'/login/:id',
      name:'login',
      meta:{
        isShowHeader: true
      },
      component: () => import( '@/project/views/Login.vue'),
    },

  ]
}
export default login;



// WEBPACK FOOTER //
// ./src/project/router/login.js